<kpi4me-text-element
  [formControlElement]="formControl"
  [data]="textElementData"
  [row]="row"
  class="form-field-no-padding"
  [hideLabel]="true"
></kpi4me-text-element>
